export default function ProblemAgitation() {
  const painPoints = [
    { icon: '📉', title: "Apps that launch but don't convert", desc: "You invested six figures and got a beautiful app that nobody uses — because revenue wasn't part of the plan." },
    { icon: '⏰', title: 'Agencies that bill hours, not results', desc: "Your agency tracks time spent, not outcomes achieved. Their incentive is to take longer, not deliver faster." },
    { icon: '🔇', title: 'Zero transparency after signing', desc: "Once the contract is signed, you're talking to an account manager who doesn't understand the code or your business." },
  ];

  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Sound Familiar?</h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Most agencies sell hours. We sell outcomes. Here's what happens when nobody's accountable for results.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {painPoints.map((p, i) => (
            <div key={i} className="bg-gray-800 p-8 rounded-xl border border-gray-700">
              <div className="text-4xl mb-4">{p.icon}</div>
              <h3 className="text-xl font-semibold mb-3 text-red-400">{p.title}</h3>
              <p className="text-gray-400">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
